import { useShippingSettings } from "@/hooks/useShipping";
import { Truck } from "lucide-react";

interface FreeShippingBarProps {
  subtotal: number;
}

const FreeShippingBar = ({ subtotal }: FreeShippingBarProps) => {
  const { data: settings } = useShippingSettings();
  const threshold = settings?.free_shipping_threshold ?? 50;

  if (threshold <= 0) return null;

  const remaining = Math.max(0, threshold - subtotal);
  const progress = Math.min(100, (subtotal / threshold) * 100);
  const achieved = remaining <= 0;

  return (
    <div className="px-1 py-3">
      <div className="flex items-center gap-2 mb-1.5">
        <Truck className={`w-4 h-4 ${achieved ? "text-green-600" : "text-muted-foreground"}`} />
        <p className="text-xs font-body font-medium">
          {achieved ? (
            <span className="text-green-600">You've unlocked free shipping! 🎉</span>
          ) : (
            <>
              Spend <span className="font-bold text-primary">£{remaining.toFixed(2)}</span> more for free shipping
            </>
          )}
        </p>
      </div>
      <div className="w-full h-2 bg-secondary rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ease-out ${
            achieved
              ? "bg-green-500"
              : "bg-primary"
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default FreeShippingBar;
